/**
 * Order Reservation Timer for Cart Sidebar
 */
class CartReservationTimer {
    constructor(elementId) {
        this.container = document.getElementById(elementId);
        if (!this.container) return;

        this.timerElement = this.container.querySelector('[data-timer]');
        this.duration = parseInt(this.container.dataset.cartCountdown) * 60; // in seconds
        
        this.init();
    }

    init() {
        // Check if there is an existing start time in sessionStorage
        let startTime = sessionStorage.getItem('cartReservationStartTime');
        if (!startTime) {
            startTime = Date.now();
            sessionStorage.setItem('cartReservationStartTime', startTime);
        }

        this.startTime = parseInt(startTime);
        this.startTimer();
    }

    startTimer() {
        this.updateTimer();
        this.interval = setInterval(() => this.updateTimer(), 1000);
    }

    updateTimer() {
        const now = Date.now();
        const elapsed = Math.floor((now - this.startTime) / 1000);
        const remaining = this.duration - elapsed;

        if (remaining <= 0) {
            clearInterval(this.interval);
            this.container.innerHTML = "Reservation expired. Checkout soon!";
            sessionStorage.removeItem('cartReservationStartTime');
            return;
        }

        const minutes = Math.floor(remaining / 60);
        const seconds = remaining % 60;

        const minutesStr = minutes < 10 ? "0" + minutes : minutes;
        const secondsStr = seconds < 10 ? "0" + seconds : seconds;

        if (this.timerElement) {
            this.timerElement.innerText = `${minutesStr}m ${secondsStr}s`;
        }
    }
}

document.addEventListener('DOMContentLoaded', () => {
    new CartReservationTimer('CartReservation-sidebar');
});

// Re-init on cart update
window.addEventListener('cartUpdated', () => {
    new CartReservationTimer('CartReservation-sidebar');
});
